module.exports = __webpack_public_path__ + "static/hcm-description-ff578746e513118a12dee0d4343e0909.jpg";